import init from './core/init'
import './fonts'
import './scss/index.scss'
import '@inv/utils/es/sentry'
import '@helper/common/bridge'

import bridge from '@helper/common/bridge'
import i18next, { tUpper } from './core/i18n'
import { UFSdk } from '@container/UserFeedback/user-feedback-h5-sdk/src/h5'

const renderOnInit = async () => {
  await init()
  UFSdk.init({
    transifyOptions: {
      i18n: i18next,
      tUpper: tUpper
    },
    webBridge: bridge
  })
  await import('./app')
}
if (window.client_configs) {
  renderOnInit()
} else {
  window.INIT_CALLBACK = () => {
    renderOnInit()
  }
}
